import { create } from 'zustand';

const useAdminInfoStore = create((set) => ({
  adminInfo: null,
  setAdminInfo: (adminInfo) => set({ adminInfo }),
  profileDetails: null,
  setProfileDetails: (profileDetails) => set({ profileDetails }),
}));

export default useAdminInfoStore;
